import { useContext } from 'react';

import DeviceContext from 'components/device/device_context';

export default function useDevice() {
  return useContext(DeviceContext);
}
